/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDescending = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m6.704 7.896 7.898 7.899H7.701c-.552 0-1.004.452-1.004 1.004 0 .551.445.997.997.997h9.32a.996.996 0 0 0 .996-.997v-9.32a.996.996 0 1 0-1.994 0v6.901L8.118 6.482a1.003 1.003 0 0 0-1.414 0 1.003 1.003 0 0 0 0 1.414" /></svg>;
export default SvgDescending;